import React, { useEffect, useLayoutEffect } from "react";
import PullToRefresh from "react-simple-pull-to-refresh";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDetailBranchPageScroll,
  fetchBranchSummaryInfo,
} from "redux/slices/sales/salesSlice";

import { isBranchPermission } from "utils/define";
import { useManagerPaymentQuery } from "queries/Sales/useManagerPaymentQuery";
import { toReferenceDate, PERIOD_COUNT } from "pages/Sales/_lib/toReferenceDate";

import MainLayout from "layouts/MainLayout";
import SummaryInfo from "./SummaryInfo";
import BranchDetailList from "./BranchDetailList";
import PullToRefreshing from "components/common/PullToRefreshing";

/**
 * [전지점 기간별 매출 조회]
 */

export const BranchDetail = ({ mode }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { searchPartner, searchDate } = useSelector(
    (state) => state.sales.branchSummaryInfo
  );
  const partnerInfo = useSelector((state) => state.partner);
  const salesInfo = useSelector((state) => state.sales);

  useLayoutEffect(() => {
    return () => {
      dispatch(fetchDetailBranchPageScroll("store"));
    };
  }, []);

  useEffect(() => {
    if (!searchPartner) {
      dispatch(
        fetchBranchSummaryInfo({
          searchPartner: partnerInfo.seqPartner,
          searchDate: salesInfo.searchDate,
          searchPeriodType: salesInfo.searchPeriodType,
        })
      );
    }
    if (!isBranchPermission(partnerInfo)) {
      navigate("/sales");
    }
  }, []);

  const query = useManagerPaymentQuery({
    seqPartner: searchPartner || partnerInfo.seqPartner,
    periodType: mode,
    referenceDate: searchDate ? toReferenceDate(mode, searchDate) : "",
    periodCount: PERIOD_COUNT[mode],
    // seqPartnerBranches 생략 → 본점 전체(branchBreakdown 포함)
  });

  const data = query.data
    ? {
        totalAmount: query.data.totalAmount,
        paymentMethods: query.data.paymentMethods,
        refund: query.data.refund,
        series: query.data.series,
      }
    : undefined;

  const eventHandler = {
    changeDate: (date) => {
      dispatch(fetchBranchSummaryInfo({ searchDate: date }));
    },
    pullToRefresh: () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          query.refetch();
          resolve();
        }, 700);
      });
    },
  };

  const render = () => {
    const periodTypeName =
      mode == "daily"
        ? "일간"
        : mode == "weekly"
          ? "주간"
          : mode == "monthly"
            ? "월간"
            : "";
    const isChart = mode != "daily";
    return (
      <PullToRefresh
        onRefresh={eventHandler.pullToRefresh}
        resistance={2}
        pullingContent={<></>}
        refreshingContent={<PullToRefreshing />}
      >
        <MainLayout
          withHeader={true}
          headerProps={{
            withBackButton: true,
            centerTitle: `전 지점 ${periodTypeName} 매출`,
          }}
          backgroundColor="white"
          withBottomTab={false}
        >
          <SummaryInfo
            mode={mode}
            date={searchDate}
            data={data}
            isChart={isChart}
            isLoading={query.isLoading}
            isError={query.isError}
            onChange={eventHandler.changeDate}
            onRefresh={() => query.refetch()}
          />
          <BranchDetailList
            mode={mode}
            branches={query.data?.branchBreakdown?.branches || []}
            searchPartner={searchPartner || partnerInfo.seqPartner}
            searchDate={searchDate}
          />
        </MainLayout>
      </PullToRefresh>
    );
  };
  return render();
};

export default BranchDetail;
